module.exports = __webpack_public_path__ + "images/04ac5430409b98117d3e595a5d122b26.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters01.jpg
// module id = ./webpack/assets/img/diaryofanant-characters01.jpg
// module chunks = 0